<template>
  <div>
    <!--begin::Content header-->
    <div
      class="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10"
    >
      <span class="font-weight-bold font-size-3 text-dark-60">
        <!-- Don't have an account yet? -->
      </span>
      <!-- <router-link
        class="font-weight-bold font-size-3 ml-2"
        :to="{ name: 'register' }"
      >
        Sign Up!
      </router-link>-->
    </div>
    <!--end::Content header-->

    <!--begin::Signin-->
    <div class="login-form login-signin">
      <div class="text-center mb-10 mb-lg-20">
        <img style="width:60%" src="/media/logos/logo-work.png" />
        <!-- logo-work.png -->
        <!-- <h3 class="font-size-h1">Sign In</h3> -->
        <p style="font-size:16px" class="text-muted mt-5 font-weight-semi-bold">四川尚匠工业技术服务有限公司</p>
      </div>
      <div class="tab-box">
        <ul class="nav nav-dark nav-bold nav-tabs nav-tabs-line" role="tablist" ref="builder-tab">
          <li class="nav-item">
            <a
              class="nav-link active"
              v-on:click="setActiveTab"
              data-tab="0"
              data-toggle="tab"
              href="javascript:;"
              role="tab"
            >登录</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              v-on:click="setActiveTab"
              data-tab="1"
              data-toggle="tab"
              href="javascript:;"
              role="tab"
            >注册</a>
          </li>
        </ul>
      </div>
      <!--begin::Form-->

      <b-form class="form" @submit.prevent="Submit">
        <b-tabs class="hide-tabs" v-model="tabIndex">
          <b-tab active>
            <b-form-group label="账户" label-for="example-input-1">
              <b-form-input
                class="form-control form-control-solid h-auto py-5 px-6"
                v-model="form.username"
                aria-describedby="input-1-live-feedback"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="example-input-group-2" label="密码" label-for="example-input-2">
              <b-form-input
                class="form-control form-control-solid h-auto py-5 px-6"
                type="password"
                v-model="form.password"
                aria-describedby="input-2-live-feedback"
              ></b-form-input>
            </b-form-group>
            <!--begin::Action-->
            <div class="form-group d-flex flex-wrap justify-content-between align-items-center">
              <a href="#" class="text-dark-60 text-hover-primary my-3 mr-2" id="kt_login_forgot">
                <!-- Forgot Password ? -->
              </a>
              <button
                ref="kt_login_signin_submit"
                @click="onSubmit()"
                class="btn btn-primary font-weight-bold px-9 py-4 my-3 font-size-3"
              >登录</button>
            </div>
            <!--end::Action-->
          </b-tab>
          <!-- 注册 -->
          <b-tab>
            <div>
              <b-form-group label="姓名" label-for="example-input-1">
                <b-form-input
                  class="form-control form-control-solid h-auto py-5 px-6"
                  v-model="form.username"
                  :state="validateState('email')"
                  aria-describedby="input-1-live-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-1-live-feedback"
                >Email is required and a valid email address.</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group label="手机号" label-for="example-input-1">
                <b-form-input
                  class="form-control form-control-solid h-auto py-5 px-6"
                  type="tel"
                  v-model="form.username"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-1-live-feedback"
                >Email is required and a valid email address.</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group label="密码" label-for="example-input-1">
                <b-form-input
                  class="form-control form-control-solid h-auto py-5 px-6"
                  type="tel"
                  v-model="form.password"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-1-live-feedback"
                >Email is required and a valid email address.</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group label="短信验证码" label-for="example-input-1">
                <b-form-input
                  class="form-control form-control-solid h-auto py-5 px-6"
                  type="tel"
                  v-model="form.email"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-1-live-feedback"
                >Email is required and a valid email address.</b-form-invalid-feedback>
              </b-form-group>
              <div class="form-group d-flex flex-wrap justify-content-between align-items-center">
                <a href="#" class="text-dark-60 text-hover-primary my-3 mr-2" id="kt_login_forgot">
                  <!-- Forgot Password ? -->
                </a>
                <button
                  ref="kt_login_signin_submit"
                  @click="onSubmit()"
                  class="btn btn-primary font-weight-bold px-9 py-4 my-3 font-size-3"
                >登录</button>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-form>
      <!--end::Form-->
    </div>
    <!--end::Signin-->
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import apiPub from "@/api/public";
import md5 from "js-md5";
import { mapState, mapGetters } from "vuex";
import { LOGIN, LOGOUT } from "@/core/services/store/auth.module";

import { validationMixin } from "vuelidate";
import { email, minLength, required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "login",
  data() {
    return {
      // Remove this dummy login info
      form: {
        username: "",
        password: ""
      },
      tabIndex: 0
    };
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(3)
      }
    }
  },
  mounted() {
    if (this.isAuthenticated) {
      // this.$router.push({ name: "home" });
    }
  },
  methods: {
    Submit() {
      return false;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    setActiveTab(event) {
      // console.log(event);
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set clicked tab index to bootstrap tab
      this.tabIndex = parseInt(event.target.getAttribute("data-tab"));
      event.target.classList.add("active");
    },
    resetForm() {
      // this.form = {
      //   email: null,
      //   password: null
      // };
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      // console.log(this.form);
      if (this.form.username == "") {
        that.$message({
          message: "请输入用户名",
          type: "warning"
        });
        return;
      }
      if (this.form.password == "") {
        that.$message({
          message: "请输入密码",
          type: "warning"
        });
        return;
      }
      var username = this.form.username;

      var that = this;
      var psd = md5(this.form.password).toUpperCase();
      var obj = {
        url: apiPub.Login,
        data: {
          UserName: username,
          PSD: psd
        }
      };
      // return;
      $http.request(obj, true, function(res) {
        // console.log(res);
        that.$store.dispatch(LOGIN, res).then(e => {
          // console.log(e);
          that.$router.push({ name: "home" });
        });
        //
      });
      return;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch(LOGIN, { email, password })
          // go to which page after successfully login
          .then(() => this.$router.push({ name: "dashboard" }));

        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }, 2000);
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    ...mapGetters(["isAuthenticated"])
  }
};
</script>
<style scoped>
.tab-box {
  width: 56%;
  margin: 0 auto;
  margin-bottom: 20px;
}
.tab-box li {
  flex: 0.4;
  text-align: center;
}
.tab-box .nav-tabs {
  border: none;
}
.tab-box li a {
  text-align: center;
  font-size: 14px;
  justify-content: center;
}
.nav.nav-tabs.nav-tabs-line .nav-link.active {
  border-bottom: 2px solid #3699ff;
  font-weight: 600;
  color: #000;
}
.form >>> .form-control.form-control-solid {
  border: none;
  border-bottom: 1px solid #e2e5ec;
  background-color: #ffff;
  border-radius: inherit;
  padding-left: 0 !important;
}
.form >>> .form-group label {
  margin-bottom: 0;
  color: #000;
  font-weight: 600;
}
</style>
